<template>
  <v-container>
      <v-row class='justify-center'>
          <v-col class='justify-center'>
              <v-card color='#00000000' elevation='0' class=" mt-5 mx-auto" width="70%">
                  <v-card-text class="justify-end">
                    <v-img
                    class="mt-8"
                    src="/ext_files/prepaid/q/media/koneLogo-orange.png"
                    max-width="250"
                    />
                    <div class="under-title">{{ $store.getters.getRafContentList.referrerWelcomeTitle }}</div>
                    <div class="share-me">
                        <!-- Αυτό είναι το μοναδικό σου link -->
                        {{getMessages['raf.dashboard.yourlink']}}
                    </div>
                    <v-text-field
                          class="link-box"
                          background-color="white"
                          rounded
                          readonly
                          :value="mailToCopy"
                          >
                          <!-- auto-grow
                          rows="1" -->
                            <template v-slot:append>
                                <v-btn
                                  color="primary"
                                  xsmall
                                  text
                                  icon
                                  @click="copyToClipboard"
                                  >
                                  <img src="/ext_files/prepaid/q/media/copyToClipboard.svg">
                                  <!-- <svg width="24" height="30" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <mask id="path-1-inside-1_2_314" fill="white">
                                    <rect x="9.0415" y="10.4115" width="18.9581" height="23.3653" rx="2.8888"/>
                                    </mask>
                                    <rect x="9.0415" y="10.4115" width="18.9581" height="23.3653" rx="2.8888" stroke="#0E28B8" stroke-width="6" mask="url(#path-1-inside-1_2_314)"/>
                                    <path d="M20.9581 7.16496V4.8888C20.9581 3.29336 19.6648 2 18.0693 2H4.8888C3.29336 2 2 3.29336 2 4.8888V21.2468C2 22.8422 3.29336 24.1356 4.8888 24.1356H6.42356" stroke="#0E28B8" stroke-width="3" stroke-linecap="round"/>
                                  </svg> -->
                                    <!-- <v-icon xsmall>mdi-content-copy</v-icon> -->
                                </v-btn>
                            </template>
                        </v-text-field>
                        <!-- <v-card rounded='xl' v-if="copied" class='pa-2 text-center'>Ο σύνδεσμος αντιγράφηκε</v-card> -->
                    <!-- <div class="reference-mail">
                        <div class="mail-input">
                            <div class="mr-10" id="mail-to-copy" ref="mail-to-copy" >{{mailToCopy}}</div>
                            <img class="copy-icon" src="/ext_files/prepaid/q/media/copyicon.png" @click="copyToClipboard">
                        </div>
                    </div> -->
                     <div class="main-text black-text">
                        <p> 
                          <!-- Γειά σου. Φέρε και τους φίλους σου στην Q με το μοναδικό σου link. Μόλις γίνουν Q, θα κερδίσετε και εσύ και οι φίλοι σου<strong> 12GB για 12 μήνες ο καθένας. </strong> -->
                          {{ $store.getters.getRafContentList.referrerWelcomeText }}
                          <!-- raf.dashboard.inviteyourfriends -->
                        </p>
                        <div class="terms-conditions">
                                {{getMessages['raf.frienddashboard.termstext']}} <a :href="$store.getters.getTermsUrl" target="_blank">{{getMessages['raf.frienddashboard.termslink']}}</a>
                                <!-- Διάβασε περισσότερα στους -->
                                <!-- Όρους και προυποθέσεις -->
                        </div>
                    </div>
                  </v-card-text>
              </v-card>
          </v-col>
          <v-col class=''>
              <v-card rounded='xl' color='#FFF9F0' elevation='0' class="justify-center mt-5 mx-auto" width="100%">
                  <v-tabs
                    v-model="platform"
                    grow
                    background-color="#FFaa89"
                    color="white"
                    dark
                    centered
                    hide-slider
                    height="60"
                    
                    
                >
                    <v-tab class='py-5' active-class='left-tab'>
                    <v-icon large>mdi-facebook</v-icon>
                    </v-tab>
                    <v-tab class='py-5' active-class='right-tab'>
                    <v-icon large>mdi-twitter</v-icon>
                    </v-tab>
                  </v-tabs>
                  <v-card-text v-if="platform === 0">
                      <div class="black-title">
                        {{getMessages['raf.dashboard.fbpost']}}
                        <!--Η ανάρτησή σου στο Facebook. -->
                      </div>
                      <v-card class="pa-5" elevation='0' outlined rounded='xl'>
                        <div class="d-flex flex-row">
                          <div class="orange-circle mt-3 pa-3 mr-3">
                            <v-img
                                class=""
                                src="/ext_files/prepaid/q/media/koneLogo-orange.png"
                                max-width="50"
                                width="50"
                            />
                          </div>
                          <div>
                            <div class="Q">Q</div>
                            <div class="banner-text">
                                <!-- Έχεις μια αποκλειστική πρόσκληση από εμένα για να κερδίσουμε και οι δύο 12GB για 12 μήνες. Χρησιμοποίησε αυτό το link και έλα στη Q. -->
                                {{ $store.getters.getRafContentList.twitterShareText }}
                                <!-- {{ $store.getters.getRafContentList.referralWelcomeTitle }} -->
                                <!-- <br>Χρησιμοποίησε αυτο το link. -->
                                <!-- {{ raf.dashboard.usethelink }} -->
                            </div>
                          </div>
                        </div>
                      </v-card>
                      <v-row class="mt-5" justify='center'>
                              <v-col class="text-center ">
                                  <v-btn @click="openLink(facebookLink)" width='264px' height="160px" elevation='0' color="#0E28B8" class="py-15 px-5" dark rounded>
                                      <div class="d-flex flex-column">
                                      <!-- <v-icon x-large>mdi-share</v-icon> -->
                                      <img class='mx-auto' src="/ext_files/prepaid/q/media/share.svg">
                                      <!-- <svg class="mx-auto" width="54" height="43" viewBox="0 0 54 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M28.1635 14.3559C9.32026 16.2597 3.75784 29.7625 3.07487 39.0157C2.99828 40.0534 4.37878 40.3472 4.93135 39.4655C11.0083 29.7691 22.0681 26.6892 28.087 26.3058C28.6439 26.2703 29.096 26.7221 29.096 27.2801V37.0086C29.096 37.8481 30.068 38.314 30.7224 37.788L51.0374 21.4607C51.5332 21.0623 51.5359 20.3084 51.0432 19.9064L30.7282 3.33167C30.075 2.79876 29.096 3.26351 29.096 4.10649V13.3479C29.096 13.8697 28.6826 14.3035 28.1635 14.3559Z" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg> -->
                                      <span class="share-btn-text mt-2">{{getMessages['raf.dashboard.shareon']}} <br>{{getMessages['raf.dashboard.facebook']}}</span>
                                      <!-- Μοιράσου το -->
                                      <!-- στo Facebook -->
                                      </div>
                                  </v-btn>
                              </v-col>
                              <v-col class="text-center ">
                                  <v-btn @click="openLink(facebookMessageLink)" width='264px' height="160px" elevation='0' color='#3FD3D0' class="py-15 px-5" rounded>
                                      <div class="d-flex flex-column">
                                      <!-- <v-icon x-large>mdi-account-multiple</v-icon> -->
                                      <img class='mx-auto' src="/ext_files/prepaid/q/media/friends.svg">
                                      <!-- <svg class="mx-auto" width="57" height="43" viewBox="0 0 57 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.253 5.61536C15.3409 5.61536 12.1695 8.78676 12.1695 12.6989C12.1695 16.611 15.3409 19.7824 19.253 19.7824C23.1651 19.7824 26.3365 16.611 26.3365 12.6989C26.3365 8.78676 23.1651 5.61536 19.253 5.61536ZM7.16947 12.6989C7.16947 6.02533 12.5794 0.615356 19.253 0.615356C25.9265 0.615356 31.3365 6.02533 31.3365 12.6989C31.3365 16.2874 29.7722 19.5106 27.2883 21.7237C28.0104 22.0895 28.6916 22.4985 29.3339 22.9432C30.5933 20.9552 32.3332 19.1158 34.6634 17.8634C33.1172 16.0942 32.184 13.7665 32.184 11.237C32.184 5.78174 36.5244 1.26509 41.9935 1.26509C47.4626 1.26509 51.803 5.78174 51.803 11.237C51.803 13.8872 50.7786 16.316 49.098 18.1129C52.1702 19.8736 54.2572 22.6173 55.5732 25.3084C56.8071 27.8316 56.2959 30.428 54.8065 32.289C53.3687 34.0854 51.0636 35.1781 48.5863 35.1781H37.5331C37.6947 37.0252 37.0816 38.7659 35.9721 40.1155C34.5113 41.8924 32.2246 42.9748 29.7471 42.9748H8.41752C6.02798 42.9748 3.79994 41.9649 2.33097 40.2779C0.827579 38.5514 0.14749 36.1238 0.964136 33.6078C2.42574 29.1047 5.44995 24.0011 10.9079 21.4379C8.60441 19.2377 7.16947 16.1359 7.16947 12.6989ZM33.0968 26.4017C34.6356 23.5079 37.2424 21.2089 41.6177 21.2089C46.5334 21.2089 49.4205 24.1083 51.0815 27.5049C51.3923 28.1405 51.291 28.6797 50.9028 29.1647C50.4629 29.7144 49.6251 30.1781 48.5863 30.1781H35.6561C34.9489 28.8824 34.1012 27.6001 33.0968 26.4017ZM5.71989 35.1514C7.4277 29.8898 11.2073 24.7824 18.7657 24.7824C26.2705 24.7824 30.3709 29.8097 32.4109 35.0344C32.6953 35.763 32.5499 36.4049 32.1098 36.9402C31.6334 37.5196 30.7846 37.9748 29.7471 37.9748H8.41752C7.41769 37.9748 6.58478 37.5491 6.10174 36.9944C5.65313 36.4792 5.49016 35.8592 5.71989 35.1514ZM37.184 11.237C37.184 8.439 39.3888 6.26509 41.9935 6.26509C44.5982 6.26509 46.803 8.439 46.803 11.237C46.803 14.035 44.5982 16.2089 41.9935 16.2089C39.3888 16.2089 37.184 14.035 37.184 11.237Z" fill="white"/>
                                      </svg> -->
                                      <span class="share-btn-text mt-2">{{getMessages['raf.dashboard.invite']}} <br> {{getMessages['raf.dashboard.yourfriends']}}</span>
                                      <!-- Προσκάλεσε τους -->
                                      <!-- φίλους σου -->
                                      </div>
                                  </v-btn>
                              </v-col>
                          </v-row>
                  </v-card-text>
                  <v-card-text v-if="platform === 1">
                      <div class="black-title">
                                {{getMessages['raf.dashboard.yourtweet']}}
                                <!-- Το tweet σου -->
                            </div>
                            <v-textarea
                                v-model="twitterText"
                                background-color="white"
                                filled
                                rounded
                                outlined
                                no-resize
                                
                            >
                            </v-textarea>
                            <div class="text-center">
                                <v-btn @click="openLink(twitterLink)" elevation='0' color="#0E28B8" class="pa-10 " dark rounded>
                                    <div class="d-flex flex-column">
                                    <v-icon>mdi-export-variant</v-icon>
                                    <span class="mt-2">{{getMessages['raf.dashboard.tweet']}}</span>
                                    <!-- Μοιράσου το στo Twitter -->
                                    </div>
                                </v-btn>
                            </div>
                  </v-card-text>
                   
              </v-card>
          </v-col>
      </v-row>
      <v-snackbar
        v-model="copied"
        timeout="3000"
        absolute
        bottom
        color="#FFaa89"
        elevation="24"
        light
      >
        <span class="text-center">Ο σύνδεσμος αντιγράφηκε</span>
        <template v-slot:action="{ attrs }">
          <v-btn
            color="black"
            text
            v-bind="attrs"
            @click="copied = false"
          >
            Κλείσιμο
          </v-btn>
        </template>
      </v-snackbar>
  </v-container>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Dashboard',
  data () {
    return {
      copied: false,
      platform: 'facebook',
      mailToCopy: '',
      twitterText: 'Έχεις μια αποκλειστική πρόσκληση από εμένα για να κερδίσουμε και οι δύο 12GB για 12 μήνες. Χρησιμοποίησε αυτό το link και έλα στη Q.'
    }
  },
  computed: {
    facebookLink () {
      return 'http://www.facebook.com/sharer.php?s=100&p[url]=' + this.mailToCopy
    },
    facebookMessageLink () {
      return 'https://www.facebook.com/dialog/send?app_id=1010645672351732&link=' + this.mailToCopy + '&redirect_uri=/iaf/wind_q_raf1'
    },
    twitterLink () {
      return 'https://twitter.com/intent/tweet?url=' + this.mailToCopy + '&text=' + this.twitterText
    },
    getMessages () {
      return this.$store.getters.getMessages
    }
  },
  methods: {
    openLink (link) {
      window.open(link, '_blank', 'width=700,height=600')
    },
    changePlatform (platform) {
      this.platform = platform
    //   this.$refs.fb.tab('hide')
    //   this.$refs.twitter.tab('show')
    },
    copyToClipboard () {
      const el = document.createElement('textarea')
      // Set value (string to be copied)
      el.value = this.mailToCopy
      // Set non-editable to avoid focus and move outside of view
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px' }
      document.body.appendChild(el)
      // Select text inside element
      el.select()
      // Copy text to clipboard
      document.execCommand('copy')
      // Remove temporary element
      document.body.removeChild(el)
      this.copied = true
    }
  },
  async mounted () {
      this.mailToCopy = this.$store.getters.getShareIdUrl
      this.twitterText = this.$store.getters.getRafContentList.twitterShareText
  }
}
</script>
